<template>
  <div>
    <div class="activeRaceClub container">
      <div class="day-selected">{{ selectedDate | moment("DD/MM/YYYY") }}</div>
      <h4>
        <span class="txtClrSkyBlue">
          <a href="javascript:void(0)" @click="$emit('hide-detail')"
            >ACTIVITIES/</a
          >
        </span>
        <span class="txtClrwt"
          >{{ singleRideData?.header_detail["title"] }} |</span
        >
        <span class="txtfontNormal">{{
          singleRideData?.header_detail["routeName"]
        }}</span>
      </h4>

      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-6">
          <div
            class="player-moniter d-flex justify-content-between align-items-end"
          >
            <div class="item">
              <p class="title">AVG. Watts</p>
              <div>
                <span class="num-count"
                  >{{ singleRideData?.header_detail["normalizePower"] }} w</span
                >
              </div>
            </div>
            <div class="item">
              <p class="title">TOTAL WORK</p>
              <div>
                <span class="num-count"
                  >{{ singleRideData?.header_detail["totalWorkout"] }} kj</span
                >
              </div>
            </div>
            <div class="item">
              <p class="title">TRAINING LOAD</p>
              <div>
                <span class="num-count">{{
                  singleRideData?.header_detail["traningLoad"]
                }}</span>
              </div>
            </div>
            <div class="item">
              <p class="title">INTENSITY</p>
              <div>
                <span class="num-count"
                  >{{ singleRideData?.header_detail["intensity"] }}%</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-6">
          <div class="btn-rece d-flex justify-content-end align-items-end">
            <a href="#" class="gen txtClr">
              {{
                genders[
                  riderData?.user?.userData["data"]["PlayerData"][
                    "PlayerProfileStruct"
                  ]["Gender"]
                ]
              }}
            </a>
            <a
              href="#"
              class="cat-list bgClrRed"
              v-if="
                riderData?.user?.userData['data']['PlayerData'][
                  'PlayerProfileStruct'
                ]['PlayerCategoryId']
              "
            >
              CAT
              {{
                riderData?.user?.userData["data"]["PlayerData"][
                  "PlayerProfileStruct"
                ]["PlayerCategoryId"]
              }}
            </a>
            <button
              class="btnCircle"
              type="button"
              @click="$emit('download-file', selectedFileId)"
            >
              <img src="/assets/images/activities/downloadCircle.png" />
            </button>
          </div>
        </div>
      </div>
      <div class="info-align">
        <div class="row d-flex align-items-center">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-6">
            <div
              class="info-activ-person d-flex justify-content-start align-items-end"
              style="display: none !important"
            >
              <div>{{ singleRideData?.header_detail["elevation"] }} m</div>
              <div>{{ singleRideData?.header_detail["distance"] }} KM</div>
              <div>{{ singleRideData?.header_detail["watt"] }} w</div>
              <div>{{ singleRideData?.header_detail["wattPerKg"] }} w/KG</div>
              <div>{{ singleRideData?.header_detail["heartrate"] }} BPM</div>
              <div>{{ singleRideData?.header_detail["rideDuration"] }}</div>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-6"></div>
        </div>
      </div>
    </div>

    <!-- Graph section -->
    <section class="graphWrpr">
      <div class="container p-0 mb-5">
        <!-- Elevation graph -->
        <div class="">
          <div class="time-row d-flex justify-content-between">
            <span class="subgraph-title">elevation map</span>
            <div class="time-note">TIME {{ hoverElevationDate }}</div>
          </div>
          <div class="grph-text d-flex justify-content-between">
            <div class="graph-box-wrpr">
              <LineChartGenerator
                class="overContainer"
                id="elevationGraph"
                ref="elevationGraph"
                :height="220"
                :chart-options="chartOptionsElevation"
                :chart-data="chartDataElevation"
              />
            </div>
            <div class="value-text">
              <div class="graphText" style="text-align: center !important">
                <p>{{ hoverElevationTime }} MIN</p>
                <p>{{ hoverElevation }} KM</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Power graph -->
        <div class="margin-left-right">
          <div class="time-row d-flex justify-content-between">
            <span class="subgraph-title">Power</span>
            <span>
              AVG <strong> {{ avgPower }} w</strong> | MAX
              <strong> {{ maxPower }} w</strong> | MIN
              <strong> {{ minPower }} w</strong>
            </span>
          </div>
          <div class="grph-text d-flex justify-content-between">
            <div class="graph-box-wrpr">
              <LineChartGenerator
                class="overContainer"
                ref="powerGraph"
                :height="220"
                :chart-options="chartOptionsPower"
                :chart-data="chartDataPower"
              />
            </div>
            <div class="value-text">
              <div class="graphText" style="text-align: center !important">
                {{ hoverPower }} <span class="txtClrBlack">w</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Speed graph -->
        <div class="margin-left-right">
          <div class="time-row d-flex justify-content-between">
            <span class="subgraph-title">Speed</span>
            <span>
              AVG <strong> {{ avgSpeed }} KM/H </strong> | MAX
              <strong> {{ maxSpeed }} KM/H </strong>
            </span>
          </div>
          <div class="grph-text d-flex justify-content-between">
            <div class="graph-box-wrpr">
              <LineChartGenerator
                class="overContainer"
                ref="speedGraph"
                :height="220"
                :chart-options="chartOptionsSpeed"
                :chart-data="chartDataSpeed"
              />
            </div>
            <div class="value-text">
              <div class="graphText" style="text-align: center !important">
                {{ hoverSpeed }} KM/H
              </div>
            </div>
          </div>
        </div>

        <!-- Heart Rate graph -->
        <div class="margin-left-right">
          <div class="time-row d-flex justify-content-between">
            <span class="subgraph-title">Heart Rate</span>
            <span>
              AVG <strong> {{ avgHeartRate }} BPM</strong> | MAX
              <strong>{{ " " + maxHeartRate }} BPM</strong> | MIN
              <strong> {{ minHeartRate }} BPM</strong>
            </span>
          </div>
          <div class="grph-text d-flex justify-content-between">
            <div class="graph-box-wrpr">
              <LineChartGenerator
                class="overContainer"
                ref="heartGraph"
                :height="220"
                :chart-options="chartOptionsHeartRate"
                :chart-data="chartDataHeartRate"
              />
            </div>
            <div class="value-text">
              <div class="graphText" style="text-align: center !important">
                {{ hoverHeartRate }}
                <span class="txtClrBlack">BPM</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Cadence graph -->
        <div class="margin-left-right">
          <div class="time-row d-flex justify-content-between">
            <span class="subgraph-title">Cadence</span>
            <span>
              AVG <strong>{{ avgCadence }} RPM</strong> | MAX
              <strong> {{ maxCadence }} RPM</strong>
            </span>
          </div>
          <div class="grph-text d-flex justify-content-between">
            <div class="graph-box-wrpr">
              <LineChartGenerator
                class="overContainer"
                ref="cadenceGraph"
                :height="220"
                :chart-options="chartOptionsCadence"
                :chart-data="chartDataCadence"
              />
            </div>
            <div class="value-text">
              <div class="graphText" style="text-align: center !important">
                {{ hoverCadence }}
                <span class="txtClrBlack">RPM</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";

export default {
  name: "ActivityDetail",
  components: {
    LineChartGenerator,
  },
  props: {
    singleRideData: {
      type: Object,
      required: true,
    },
    riderData: {
      type: Object,
      required: true,
    },
    genders: {
      type: Array,
      required: true,
    },
    selectedDate: {
      type: String,
      required: true,
    },
    selectedFileId: {
      type: String,
      required: true,
    },
    chartOptionsElevation: {
      type: Object,
      required: true,
    },
    chartDataElevation: {
      type: Object,
      required: true,
    },
    chartOptionsPower: {
      type: Object,
      required: true,
    },
    chartDataPower: {
      type: Object,
      required: true,
    },
    chartOptionsSpeed: {
      type: Object,
      required: true,
    },
    chartDataSpeed: {
      type: Object,
      required: true,
    },
    chartOptionsHeartRate: {
      type: Object,
      required: true,
    },
    chartDataHeartRate: {
      type: Object,
      required: true,
    },
    chartOptionsCadence: {
      type: Object,
      required: true,
    },
    chartDataCadence: {
      type: Object,
      required: true,
    },
    hoverElevationDate: {
      type: String,
      required: true,
    },
    hoverElevationTime: {
      type: String,
      required: true,
    },
    hoverElevation: {
      type: Number,
      required: true,
    },
    hoverPower: {
      type: Number,
      required: true,
    },
    hoverSpeed: {
      type: Number,
      required: true,
    },
    hoverHeartRate: {
      type: Number,
      required: true,
    },
    hoverCadence: {
      type: Number,
      required: true,
    },
    avgPower: {
      type: String,
      required: true,
    },
    minPower: {
      type: String,
      required: true,
    },
    maxPower: {
      type: String,
      required: true,
    },
    avgSpeed: {
      type: String,
      required: true,
    },
    maxSpeed: {
      type: String,
      required: true,
    },
    avgHeartRate: {
      type: String,
      required: true,
    },
    maxHeartRate: {
      type: String,
      required: true,
    },
    minHeartRate: {
      type: String,
      required: true,
    },
    avgCadence: {
      type: String,
      required: true,
    },
    maxCadence: {
      type: String,
      required: true,
    },
  },
  emits: ["hide-detail", "download-file"],
};
</script>
